/**
 * Mode d'organisation du serveur (`local` | `registre`, décision D-J du lot O3) lu sur la session.
 *
 * Tolérant par construction : hors `SessionProvider` (ou avec une session qui ne porte pas le
 * mode) on retombe sur `local`, le comportement d'avant le lot — c'est ce qui garantit qu'un
 * écran qui n'a rien à faire du registre ne change pas d'un octet.
 */

import { useSession } from '../contexts/SessionContext.jsx';

/** @returns {'local'|'registre'} */
export function useOrganisationStudio() {
  try {
    return useSession().organisationStudio === 'registre' ? 'registre' : 'local';
  } catch {
    return 'local';
  }
}
